<template>
  <v-alert
    colored-border
    border="left"
    color="primary"
    class="share-banner mb-6"
    elevation="0"
  >
    <div class="d-flex flex-wrap align-center">
      <div class="flex-grow-1 pr-4 mb-3 mb-sm-0">
        <div class="font-weight-bold mb-1">{{ $t('share.bannerTitle') }}</div>
        <div class="body-2">{{ $t('share.bannerBody') }}</div>
      </div>
      <v-btn
        depressed
        color="primary"
        class="text-none"
        @click="goRegister"
      >
        {{ $store.getters.authenticated ? $t('share.openOwn') : $t('share.register') }}
      </v-btn>
    </div>
  </v-alert>
</template>

<script lang="ts">
    import Vue from 'vue';
    import {Store} from '@/plugins/Store';

    export default Vue.extend({
        name: 'SharePreviewBanner',
        methods: {
            goRegister(): void {
                Store.commit('clearSharePreview');
                this.$router.push({name: 'Home'});
            }
        }
    });
</script>

<style scoped lang="sass">
.share-banner
    border-radius: 16px !important
</style>
